import React from 'react';
import styled, { keyframes } from 'styled-components';


const CubeGrid = styled.div`
width: ${(props) => props.width}px;
height: ${(props) => props.height}px;
`;

const cubeGridScaleDelay = keyframes`
0%, 70%, 100% {
  -webkit-transform: scale3D(1, 1, 1);
          transform: scale3D(1, 1, 1);
} 35% {
  -webkit-transform: scale3D(0, 0, 1);
          transform: scale3D(0, 0, 1);
}
`

const Cube = styled.div`
width: 33%;
height: 33%;
background-color: #333;
float: left;
animation: ${cubeGridScaleDelay} 1.3s infinite ease-in-out;
`;

const Cube1 = Cube.extend`
animation-delay: 0.2s;
`;

const Cube2 = Cube.extend`
animation-delay: 0.3s;
`;

const Cube3 = Cube.extend`
animation-delay: 0.4s;
`;

const Cube4 = Cube.extend`
animation-delay: 0.1s;
`;

const Cube5 = Cube.extend`
animation-delay: 0.2s;
`;

const Cube6 = Cube.extend`
animation-delay: 0.3s;
`;

const Cube7 = Cube.extend`
animation-delay: 0s;
`;

const Cube8 = Cube.extend`
animation-delay: 0.1s;
`;

const Cube9 = Cube.extend`
animation-delay: 0.2s;
`;

export default function CubeSpiner({ width = 100, height = 100 }: { width?: number, height?: number}) {
  return (
    <CubeGrid width={width} height={height}>
      <Cube1 />
      <Cube2 />
      <Cube3 />
      <Cube4 />
      <Cube5 />
      <Cube6 />
      <Cube7 />
      <Cube8 />
      <Cube9 />
    </CubeGrid>
  );
}


// WEBPACK FOOTER //
// ./src/components/spiners/CubeSpiner/index.js